import * as Yup from "yup"

export const getAcceptableTypesOfIdentificationValidationSchema = (name: string) => {
	return Yup.object().shape({
		[name]: Yup.object().shape({
			individual: Yup.object()
				.shape({
					ssn: Yup.boolean(),
					itin: Yup.boolean(),
					passport: Yup.boolean(),
					matriculaConsular: Yup.boolean(),
				})
				.test(
					"at-least-one-individual",
					"At least 1 item must be selected",
					(value) => value && Object.values(value).some((val) => val === true)
				),
			soleProprietor: Yup.object()
				.shape({
					ssn: Yup.boolean(),
					itin: Yup.boolean(),
					passport: Yup.boolean(),
					matriculaConsular: Yup.boolean(),
				})
				.test(
					"at-least-one-individual",
					"At least 1 item must be selected",
					(value) => value && Object.values(value).some((val) => val === true)
				),
			businessBeneficialOwnerOrOfficer: Yup.object()
				.shape({
					ssn: Yup.boolean(),
					itin: Yup.boolean(),
					passport: Yup.boolean(),
					matriculaConsular: Yup.boolean(),
				})
				.test(
					"at-least-one-bbo",
					"At least 1 item must be selected",
					(value) => value && Object.values(value).some((val) => val === true)
				),
		}),
	})
}
